import React from 'react';

const Reports = () => {
  return (
    <div className="reports">
      <div className="page-header">
        <h2>Raporlar</h2>
        <p>Sistem raporlarını görüntüleyin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default Reports; 